import styled from 'styled-components';
import { Flex } from '@ui-library/flex';

export const ModalOverlay = styled(Flex).attrs({ centered: true })`
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 500;
  transition: all 0.3s ease-out;
  background-color: rgba(0, 0, 0, 0.5);
`;
